import { Link } from 'react-router-dom';

interface HotRankListProps {
  items: { rank: number; keyword: string; tag?: string; topicId: string }[];
  title?: string;
}

export default function HotRankList({ items, title = '实时讨论榜' }: HotRankListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-bar-chart-2-line text-primary-500" aria-hidden="true" />
          {title}
        </h3>
        <span className="flex items-center gap-1 text-[11px] text-foreground-500">
          <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-500" />
          实时更新
        </span>
      </div>

      <ol className="mt-4 flex flex-col">
        {items.map((item) => (
          <li key={item.rank} className="border-b border-background-100 last:border-b-0">
            <Link
              to={`/topic/${item.topicId}`}
              className="group flex items-start gap-3 py-2.5"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-black ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 text-[13px] leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                {item.keyword}
              </span>
              {item.tag && (
                <span
                  className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] font-bold ${
                    item.tag === '爆'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热'
                        ? 'bg-accent-200 text-accent-900'
                        : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {item.tag}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}